import React from 'react';

/*import AppLoader from '../../../AppLoader';
import LoadingProgressTutorial from '../../../LoadingProgressTutorial';*/
import AppLoader from '../../../../../../ek/modules/dashboard/components/AppLoader';
import LoadingProgressTutorial from '../../../../../../ek/modules/dashboard/components/LoadingProgressTutorial';

import { useCoreWeaveProgressBar } from './hooks';

const CoreWeaveLoader = () => {
  const {
    secondStepLoading,
    secondStepCompleted,
    thirdStepLoading,
    thirdStepCompleted,
    forthStepLoading,
    forthStepCompleted,
  } = useCoreWeaveProgressBar();

  return (
    <AppLoader>
      <LoadingProgressTutorial
        secondStepLoading={secondStepLoading}
        secondStepCompleted={secondStepCompleted}
        thirdStepLoading={thirdStepLoading}
        thirdStepCompleted={thirdStepCompleted}
        forthStepLoading={forthStepLoading}
        forthStepCompleted={forthStepCompleted}
      />
    </AppLoader>
  );
};

export default CoreWeaveLoader;
